import { render, staticRenderFns } from "./mobile_projectorbit.vue?vue&type=template&id=5086dbe6&scoped=true"
import script from "./mobile_projectorbit.vue?vue&type=script&lang=js"
export * from "./mobile_projectorbit.vue?vue&type=script&lang=js"
import style0 from "./mobile_projectorbit.vue?vue&type=style&index=0&id=5086dbe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5086dbe6",
  null
  
)

export default component.exports